export default "__VITE_ASSET__DzzL4Mjb__"